import { createAction, props } from '@ngrx/store';

import { MaterialEntity } from '../../entities/material.entity';

const prefix = 'data/' + 'material/';
export const MaterialActionTypes = {
    CreateSuccess: createAction(prefix + 'createSuccess', props<{ Payload: MaterialEntity }>()),
};
